// extracted by mini-css-extract-plugin
export default {"helloMessageContainer":"style_helloMessageContainer__sHNfY","monitoringContainer":"style_monitoringContainer__elBW0"};